import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { DigitalQuote } from './types';

export type UseDigitalQuoteParams = {
  digiQuoteKey: string;
  isPreview: boolean;
};

export const getDigitalQuoteQueryKey = (params: UseDigitalQuoteParams) =>
  ['digitalQuote', params] as const;
export type DigitalQuoteQueryKey = ReturnType<typeof getDigitalQuoteQueryKey>;

export const useDigitalQuote: QueryFunction<
  DigitalQuote,
  [UseDigitalQuoteParams],
  DigitalQuoteQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getDigitalQuoteQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/quotes/key/${params.digiQuoteKey}`, {
        query: {
          mode: params.isPreview ? 'preview' : undefined,
        },
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
